/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/rewards/series_data';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "FetchEarnedRewardsRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "year": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FetchEarnedRewardsResponse": {
                "fields": {
                  "series": {
                    "type": ".squareup.corporate_card.resources.rewards.SeriesData",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.FetchEarnedRewardsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.FetchEarnedRewardsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FetchEarnedRewardsRequest @ squareup/corporate_card/service/fetch_earned_rewards.proto at 9:1
 */
export const FetchEarnedRewardsRequest = $root.lookupType('squareup.corporate_card.service.FetchEarnedRewardsRequest');
fixType(FetchEarnedRewardsRequest);
Builder.createAndAttachToType(FetchEarnedRewardsRequest);
/**
 * SOURCE FetchEarnedRewardsResponse @ squareup/corporate_card/service/fetch_earned_rewards.proto at 22:1
 */
export const FetchEarnedRewardsResponse = $root.lookupType('squareup.corporate_card.service.FetchEarnedRewardsResponse');
fixType(FetchEarnedRewardsResponse);
Builder.createAndAttachToType(FetchEarnedRewardsResponse);